// Transport service text for the preview item card, matching legacy V2 EXACTLY.
//
// Used by BOTH the main item's meta row and the transport subitem row. V2 ran
// the same expression in both places; the port originally hand-rolled the main
// item's copy, which dropped the " Day" suffix (a car rental read "Full"
// instead of "Full Day") and invented a "Transfer" fallback V2 never showed.
// One function so the two cannot drift again.
//
// V2 source of truth:
//   - travel_planner_front/components/display/ItineraryItemPreview/TravelInfo.tsx
//     (main item, lines 85-87: `serviceType === "Full" || serviceType === "Half"
//      ? serviceType + " Day" : serviceType || null`)
//   - travel_planner_front/components/display/ItineraryItemPreview/SubitemBlock.tsx
//     (transport row: `getSubitemIcon("Transport")` renders ONLY the <Car>
//      icon, then `<span>{ isServiceType ? value + " Day" : value }</span>`)
//   - travel_planner_front/lib/utils/itinerary-item-processor.ts (line ~241:
//     for a Transport subitem, `value = subitem.serviceType || ""`)
//
// So V2 shows the Car icon PLUS a serviceType-derived text — NOT `transportType`
// (Sedan/Bus), and NOT any "Transport"/"Transfer" fallback word:
//   serviceType 'Full' | 'Half'      -> "Full Day" / "Half Day"
//   any other non-empty serviceType  -> that raw value
//   empty / absent serviceType       -> "" (V2 renders an empty span -> the
//                                        transport subitem is just the bare
//                                        Car icon; this is intended V2 behavior)

export const resolveTransportServiceText = (source: {
  serviceType?: string | null;
}): string => {
  const value =
    typeof source.serviceType === 'string' ? source.serviceType : '';
  return value === 'Full' || value === 'Half' ? `${value} Day` : value;
};
